<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>服务器/FTP维护</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      服务器/FTP维护
    </h1>
    <div class="view-content">
      <el-form ref="form" :model="form" :rules="rules" :disabled="!isEdit" label-width="96px">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>服务器信息维护</span>
          </div>
          <div class="card-content">
            <el-form-item label="服务器名称" prop="serverName">
              <el-input v-model="form.serverName"></el-input>
            </el-form-item>
            <el-form-item label="服务器地址" prop="serverName">
              <el-input v-model="form.serverAddress"></el-input>
            </el-form-item>
          </div>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>FTP信息维护</span>
          </div>
          <div class="card-content">
            <el-form-item label="FTP地址" prop="FTPAddress">
              <el-input v-model="form.FTPAddress"></el-input>
            </el-form-item>
            <el-form-item label="端口" prop="FTPPort">
              <el-input v-model="form.FTPPort"></el-input>
            </el-form-item>
            <el-form-item label="用户名" prop="FTPUsername">
              <el-input v-model="form.FTPUsername"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="FTPPassword">
              <el-input v-model="form.FTPPassword"></el-input>
            </el-form-item>
            <el-form-item label="保存路径" prop="FTPSavedPath">
              <el-input v-model="form.FTPSavedPath"></el-input>
            </el-form-item>
          </div>
        </el-card>
        <el-form-item class="no-lable" v-if="isEdit">
          <el-button type="primary" @click="onSubmit('form')" :loading="isLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
    import {companySetServer, getCompanyServer} from '@/api/index';

    export default {
        name: "ServerFTPMaintenance",
        data: () => ({
            form: {
                serverName: '',
                serverAddress: '',
                FTPAddress: '',
                FTPPort: '',
                FTPUsername: '',
                FTPPassword: '',
                FTPSavedPath: ''
            },
            isEdit: false,
            isLoading: false,
            rules: {
                serverName: [
                    {required: true, message: '请输入服务器名称', trigger: 'blur'}
                ],
                serverAddress: [
                    {required: true, message: '请输入服务器地址', trigger: 'blur'}
                ],
                FTPAddress: [
                    {required: true, message: '请输入FTP地址', trigger: 'blur'}
                ],
                FTPPort: [
                    {required: true, message: '请输入端口', trigger: 'blur'}
                ],
                FTPUsername: [
                    {required: true, message: '请输入用户名', trigger: 'blur'}
                ],
                FTPPassword: [
                    {required: true, message: '请输入密码', trigger: 'blur'}
                ],
                FTPSavedPath: [
                    {required: true, message: '请输入保存路径', trigger: 'blur'}
                ],
            }
        }),
        created() {
            getCompanyServer().then(res => {
                if (0 === res.status) {
                    const data = res.data;
                    // TODO:ftp_route
                    this.isEdit = !(data.server_name && data.server_name !== '');
                    this.form = {
                        serverName: data.server_name,
                        serverAddress: data.server_address,
                        FTPAddress: data.ftp_address,
                        FTPPort: data.ftp_port,
                        FTPUsername: data.ftp_name,
                        FTPPassword: data.ftp_password,
                        FTPSavedPath: data.ftp_route
                    };
                }
            })
        },
        methods: {
            onSubmit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.isLoading = true;
                        let values = {...this[formName]};
                        let parameter = {
                            server_name: values.serverName,
                            server_address: values.serverAddress,
                            ftp_address: values.FTPAddress,
                            ftp_port: values.FTPPort,
                            ftp_name: values.FTPUsername,
                            ftp_password: values.FTPPassword,
                            ftp_route: values.FTPSavedPath
                        };
                        companySetServer(parameter).then(res => {
                            this.isLoading = false;
                            if (0 === res.status) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success'
                                });
                                this.isEdit = false;
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    }
                });

            }
        }
    }
</script>

<style scoped lang="scss">
  .card-content {
    width: 460px;
  }

  .box-card {
    margin-bottom: 20px;
  }
</style>